<template>
    <ContainerLayout page="0">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div v-if="showForm == 0" class="content pb-3">
            <!-- <div class="card"> -->
            <!-- <div class="card-header justify-content-center align-items-center text-center">
                    <label class="my-0">
                        {{ $t('Welcome to The Company Registration') }}
                    </label>
                </div> -->
            <div class="d-flex flex-column justify-content-center align-items-center text-center pb-5">
                <label class="mt-0 mb-3 font-weight-bold" style="font-size: 1.5rem;">
                    {{ $t('Join us on') }} {{ appName }}
                </label>
                <label v-if="companies.length > 0" class="mb-2 badge-custom badge-outlined badge-main"
                    style="font-weight: 500; font-size: 1rem; padding: 0.5rem 1rem;">
                    {{ $t('Our Partners') }}
                </label>
                <div v-if="companies.length > 0" class="w-100 row d-flex justify-content-center align-items-center">
                    <div v-for="(company, index) in companies" :key="index" class="col-6 col-md-4 col-lg-3">
                        <img v-if="index < 6" :src="company.image_url"
                            style="width: 100%; height: 80px; object-fit: contain;" />
                    </div>
                </div>
                <span v-if="companies.length > 6" class="text-muted"
                    style="font-weight: 500; font-size: 12px; padding: 0.5rem 1rem;">
                    +{{ companies.length - 6 }} {{ $t('More') }}
                </span>
                <label v-if="providers.length > 0" class="mb-2 badge-custom badge-outlined badge-main"
                    :class="companies.length > 0 ? 'mt-5' : ''"
                    style="font-weight: 500; font-size: 1rem; padding: 0.5rem 1rem;">
                    {{ $t('Our Providers') }}
                </label>
                <div v-if="providers.length > 0" class="w-100 row d-flex justify-content-center align-items-center">
                    <div v-for="(provider, index) in providers" :key="index" class="col-6 col-md-4 col-lg-3">
                        <img v-if="index < 6" :src="provider.image_url"
                            style="width: 100%; height: 80px; object-fit: contain;" />
                    </div>
                </div>
                <span v-if="providers.length > 6" class="text-muted"
                    style="font-weight: 500; font-size: 12px; padding: 0.5rem 1rem;">
                    +{{ providers.length - 6 }} {{ $t('More') }}
                </span>
            </div>
            <hr class="mt-3 mb-0 full-hr" style="border-top: 3px solid rgba(0,0,0,.1);">
            <div v-if="companies.length > 0" class="w-100 d-flex flex-column align-items-center">
                <label class="mb-2">
                    {{ $t('Your company already registered?') }}
                </label>
                <button class="btn btn-secondary btn-block" :disabled="loading" @click="goAccountSubmission()">
                    <span>{{ $t('Submit Your Account Request') }}</span>
                </button>
                <label class="mb-0">
                    {{ $t('Or') }}
                </label>
            </div>
            <button class="btn btn-main btn-block mt-3" :disabled="loading" @click="showForm = 1">
                <span>{{ $t('Register Company Now') }}</span>
            </button>
            <!-- </div> -->
        </div>
        <div v-if="showForm == 1" class="content px-1">
            <label class="mb-4">
                <!-- (1/4)  -->
                {{ $t('Please enter company information to complete the registration process') }}
            </label>
            <Form @submit="handleRegister" :validation-schema="schema" :initial-values="initialValues" autocomplete="off"
                enctype="multipart/form-data">
                <div class="form-group">
                    <label style="font-weight: 600;" for="name">{{ $t('Company Name') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="name" type="text" class="form-control" />
                    <ErrorMessage name="name" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="type">{{ $t('Company Type') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="company_type_id" as="select" class="form-control" @change="handleTypeChange">
                        <option value="" disabled selected>{{ $t('Select Company Type') }}</option>
                        <option v-for="(type, index) in company_types" :key="index" :value="type.id">{{ type.current_name }}
                        </option>
                        <option value="other">{{ $t('Other') }}</option>
                    </Field>
                    <ErrorMessage name="company_type_id" class="error-feedback" />
                </div>
                <div v-if="showInputCompanyType" class="form-group">
                    <Field v-model="input_company_type" name="input_company_type" type="text" class="form-control"
                        :placeholder="$t('Input Company Type')" />
                    <ErrorMessage name="input_company_type" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="image">
                        {{ $t('Company Logo') }} <sup class="text-muted">{{ $t('optional') }}</sup>
                        <br>
                        <small class="text-muted">( {{ $t('images max 5MB') }} )</small>
                    </label>
                    <Field name="image" type="file" accept="image/*" class="file-input" @change="handleImageChange" />
                    <hr class="mt-2 mb-1">
                    <ErrorMessage name="image" class="error-feedback" />
                </div>
                <div v-if="imagePreview" class="w-100 text-center">
                    <img :src="imagePreview" alt="Preview" style="max-width: 100%; max-height: 200px;">
                </div>
                <hr class="my-4 full-hr-second" style="border-top: 3px solid rgba(0,0,0,.1);">
                <div class="form-group">
                    <label style="font-weight: 600;" for="company_position">{{ $t('Your Position') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="company_position" type="text" class="form-control" />
                    <ErrorMessage name="company_position" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="company_department">{{ $t('Your Unit') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="company_department" type="text" class="form-control" />
                    <ErrorMessage name="company_department" class="error-feedback" />
                </div>
                <hr class="my-4 full-hr-second" style="border-top: 3px solid rgba(0,0,0,.1);">
                <div class="form-group">
                    <label style="font-weight: 600;" for="is_pkp">{{ $t('Company Tax Category') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="is_pkp" as="select" class="form-control" @change="handleCategoryChange">
                        <option value="0" selected>Non-Pengusaha Kena Pajak (Non-PKP)</option>
                        <option value="1">Pengusaha Kena Pajak (PKP)</option>
                    </Field>
                    <ErrorMessage name="is_pkp" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="npwp_number">{{ $t('NPWP Number') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="npwp_number" type="text" class="form-control" />
                    <ErrorMessage name="npwp_number" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="npwp_file">
                        {{ $t('NPWP') }} <sup class="text-danger">*</sup>
                        <br>
                        <small class="text-muted">( {{ $t('.pdf / images max 5MB') }} )</small>
                    </label>
                    <Field name="npwp_file" type="file" accept="application/pdf , image/*" class="file-input"
                        @change="handleFileChange" />
                    <hr class="mt-2 mb-1">
                    <ErrorMessage name="npwp_file" class="error-feedback" />
                </div>
                <div id="sppkp_file" class="form-group" style="display: none;">
                    <label style="font-weight: 600;" for="sppkp_file">
                        {{ $t('SPPKP') }} <sup class="text-danger">*</sup>
                        <br>
                        <small class="text-muted">( {{ $t('.pdf / images max 5MB') }} )</small>
                    </label>
                    <Field name="sppkp_file" type="file" accept="application/pdf , image/*" class="file-input"
                        @change="handleFileChange" />
                    <hr class="mt-2 mb-1">
                    <ErrorMessage name="sppkp_file" class="error-feedback" />
                </div>
                <div id="skt_file" class="form-group" style="display: none;">
                    <label style="font-weight: 600;" for="skt_file">
                        {{ $t('SKT') }} <sup class="text-danger">*</sup>
                        <br>
                        <small class="text-muted">( {{ $t('.pdf / images max 5MB') }} )</small>
                    </label>
                    <Field name="skt_file" type="file" accept="application/pdf , image/*" class="file-input"
                        @change="handleFileChange" />
                    <hr class="mt-2 mb-1">
                    <ErrorMessage name="skt_file" class="error-feedback" />
                </div>
                <div class="form-group pt-3">
                    <button class="btn btn-main btn-block" :disabled="loading">
                        <span>{{ $t('Register') }}</span>
                    </button>
                </div>
            </Form>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../../ContainerLayout.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import CompanyService from "@/services/company.service";

export default {
    name: "CompanyRegistration",
    components: {
        ContainerLayout,
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const schema = yup.object().shape({
            name: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Name") })),
            company_type_id: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Company Type") })),
            company_position: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Position") })),
            company_department: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Unit") })),
            is_pkp: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Company Tax Category") })),
            npwp_number: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("NPWP Number") })),
            npwp_file: yup
                .mixed()
                .required(this.$t("Data is required!", { data: "NPWP" })),
            sppkp_file: yup
                .mixed()
                .when('is_pkp', {
                    is: (value) => value === "1",
                    then: () => yup.mixed().required(this.$t("Data is required!", { data: "SPPKP" })),
                    otherwise: () => yup.mixed().nullable(),
                }),
            skt_file: yup
                .mixed()
                .when('is_pkp', {
                    is: (value) => value === "1",
                    then: () => yup.mixed().required(this.$t("Data is required!", { data: "SKT" })),
                    otherwise: () => yup.mixed().nullable(),
                }),
        });

        return {
            initialValues: {
                name: "",
                company_type_id: "",
                company_position: "",
                company_department: "",
                image: null,
                is_pkp: "0",
                npwp_number: "",
                npwp_file: null,
                sppkp_file: null,
                skt_file: null,
            },
            loading: false,
            schema,
            company_types: [],
            showInputCompanyType: false,
            input_company_type: "",
            showForm: 0,
            companies: [],
            providers: [],
            imagePreview: null,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
    },
    created() {
        if (this.currentUser && this.currentUser.company_id != null) {
            this.$router.push("/");
        }
        if (this.$route.query.data) {
            let decrypted = this.$decryptString(this.$route.query.data, 'encryptKey');
            if (decrypted != null && decrypted.indexOf("{") != -1) {
                this.showForm = 1;
                this.initialValues = { ...this.initialValues, ...JSON.parse(decrypted) };

                if (this.initialValues.company_type_id == 'other') {
                    this.input_company_type = this.initialValues.input_company_type;
                    this.showInputCompanyType = true;
                } else {
                    this.input_company_type = '';
                    this.showInputCompanyType = false;
                }
            }
        }

        this.loading = true;
        let loader = this.$loading.show();

        CompanyService.getAllType()
            .then((response) => {
                if (response.data.status === 'success') {
                    this.company_types = response.data.data;
                }
            })
            .catch(() => {
                // console.error(error);
            });

        CompanyService.getAll()
            .then((response) => {
                if (response.data.status === 'success') {
                    this.companies = response.data.data;
                }
            })
            .catch(() => {
                // console.error(error);
            });

        CompanyService.getAllProvider()
            .then((response) => {
                this.loading = false;
                loader.hide();

                if (response.data.status === 'success') {
                    this.providers = response.data.data;
                }
            })
            .catch(() => {
                this.loading = false;
                loader.hide();

                // console.error(error);
            });
    },
    methods: {
        goBack() {
            if (this.showForm == 0) {
                this.navigateBackOrHome();
            } else {
                this.showForm = 0;
            }
        },

        goAccountSubmission() {
            this.$router.push({
                name: "Account Submission",
                query: { from: 'company-registration' }
            });
        },

        handleCategoryChange(event) {
            if (event.target.value == 0) {
                document.getElementById("sppkp_file").style.display = "none";
                document.getElementById("skt_file").style.display = "none";
            } else {
                document.getElementById("sppkp_file").style.display = "block";
                document.getElementById("skt_file").style.display = "block";
            }
        },

        handleImageChange(event) {
            let file = event.target.files[0];
            if (file) {
                const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
                if (!validImageTypes.includes(file.type)) {
                    this.$vueAlert.alert(this.$t('Please upload an image file'), this.$t('Invalid file format'), 'error');
                    event.target.value = "";
                    return;
                }

                if (file.size > 5000000) {
                    this.$vueAlert.alert(this.$t('Please upload a file with a maximum size of 5MB'), this.$t('File size is too large'), 'error');
                    event.target.value = "";
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            } else {
                this.imagePreview = null;
            }
        },

        handleFileChange(event) {
            let file = event.target.files[0];
            if (file) {
                const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'application/pdf'];
                if (!validTypes.includes(file.type)) {
                    this.$vueAlert.alert(this.$t('Please upload an image or PDF file'), this.$t('Invalid file format'), 'error');
                    event.target.value = "";
                    return;
                }

                if (file.size > 5000000) {
                    this.$vueAlert.alert(this.$t('Please upload a file with a maximum size of 5MB'), this.$t('File size is too large'), 'error');
                    event.target.value = "";
                    return;
                }

                // const reader = new FileReader();
                // reader.onload = (e) => {
                //     this.filePreview = e.target.result;
                // };
                // reader.readAsDataURL(file);
            } else {
                // this.filePreview = null;
            }
        },

        handleRegister(company) {
            if (this.showInputCompanyType) {
                if (company.input_company_type == '' || company.input_company_type == null) {
                    this.$vueAlert.alert(this.$t('Data is required!', { data: this.$t('Company Type') }), null, 'error');
                    return;
                }
            }

            this.loading = true;
            let loader = this.$loading.show();

            let user_id = { user_id: this.currentUser.id };
            company = { ...company, ...user_id };
            CompanyService
                .store(company)
                .then((response) => {
                    this.loading = false;
                    loader.hide();
                    if (response.data.status == 'success') {
                        this.$vueAlert.alert(this.$t('Please re-login to continue'), null, 'success').then(() => {
                            this.$store.dispatch("auth/logout");
                            this.$router.push("/login");
                        });
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },

        handleTypeChange(event) {
            this.input_company_type = '';
            if (event.target.value == 'other') {
                this.showInputCompanyType = true;
            } else {
                this.showInputCompanyType = false;
            }
        },
    }
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.form-control {
    border-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}

.full-hr {
    margin-left: -16px;
    margin-right: -16px;
}

.full-hr-second {
    margin-left: -20px;
    margin-right: -20px;
}
</style>
  